/* BOSSVI · Ventana de bienvenida (14 oct 2026) · sections/bossvi-bienvenida.liquid */
(function () {
  var d = document.getElementById('BvBienvenida');
  if (!d || typeof d.showModal !== 'function') return;
  var CLAVE = 'bv_bienvenida', ENVIADO = 'bv_bienvenida_enviado';
  var retraso = (parseFloat(d.getAttribute('data-retraso')) || 5) * 1000;
  var dias = parseFloat(d.getAttribute('data-dias')) || 30;
  var enEditor = d.getAttribute('data-editor') === '1';
  var estadoEl = d.querySelector('[data-bv-estado]');
  var estado = estadoEl ? estadoEl.getAttribute('data-bv-estado') : '';

  function leer() { try { return JSON.parse(localStorage.getItem(CLAVE) || 'null'); } catch (e) { return null; } }
  function guardar(v) { try { localStorage.setItem(CLAVE, JSON.stringify(v)); } catch (e) {} }
  function abrir() {
    if (d.open) return;
    if (document.querySelector('dialog[open]')) { setTimeout(abrir, 3000); return; }
    try { d.showModal(); } catch (e) { return; }
    var t = d.querySelector(d.classList.contains('is-ok') ? '.bv-bv__paso--2 .bv-bv__titulo' : '.bv-bv__paso--1 .bv-bv__titulo');
    if (t) t.focus({ preventScroll: true });
  }

  var vieneDeAqui = false;
  try { vieneDeAqui = sessionStorage.getItem(ENVIADO) === '1'; sessionStorage.removeItem(ENVIADO); } catch (e) {}

  // Cerrar: X, «Ahora no», tecla Esc o toque fuera de la tarjeta
  Array.prototype.forEach.call(d.querySelectorAll('[data-bv-cerrar]'), function (b) {
    b.addEventListener('click', function () { d.close(); });
  });
  d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
  d.addEventListener('close', function () {
    if (!d.classList.contains('is-ok') && !enEditor) guardar({ s: 'cerrada', t: Date.now() });
  });

  // Enviar: se recuerda que el envío sale de esta ventana para abrirla en «Ya es tuyo» al volver
  var form = d.querySelector('form');
  var email = d.querySelector('#BvBienvenidaEmail');
  var error = d.querySelector('[data-bv-error]');
  if (form) form.addEventListener('submit', function (e) {
    if (email && !email.checkValidity()) {
      e.preventDefault();
      if (error) error.hidden = false;
      email.setAttribute('aria-invalid', 'true');
      email.setAttribute('aria-describedby', 'BvBienvenidaError');
      email.focus();
      return;
    }
    try { sessionStorage.setItem(ENVIADO, '1'); } catch (e2) {}
  });

  // Copiar el código
  var copiar = d.querySelector('[data-bv-copiar]');
  var codigo = d.querySelector('[data-bv-codigo]');
  if (copiar && codigo) copiar.addEventListener('click', function () {
    var txt = codigo.textContent.trim();
    var hecho = function () { copiar.textContent = 'Copiado'; setTimeout(function () { copiar.textContent = 'Copiar'; }, 2500); };
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(txt).then(hecho, function () {}); }
    else { var r = document.createRange(); r.selectNodeContents(codigo); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); }
  });

  // Vuelta del envío
  if (estado === 'ok') {
    guardar({ s: 'suscrita', t: Date.now() });
    if (vieneDeAqui) { d.classList.add('is-ok'); abrir(); }
    return;
  }
  if (estado === 'error' && vieneDeAqui) { abrir(); return; }

  // Primera visita: espera y respeta lo que ya hizo esta persona
  if (!enEditor) {
    var v = leer();
    if (v && v.s === 'suscrita') return;
    if (v && v.s === 'cerrada' && Date.now() - v.t < dias * 864e5) return;
  }
  setTimeout(abrir, enEditor ? 400 : retraso);
})();